import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../components/hooks';
import { getSingleSelectedItemEntryOrNull } from '../store/selectors/getSelectedItemSelector';
import { isLayoutViewActive } from '../store/selectors/layoutModeSelectors';
import { inViewOnlyMode } from '../store/selectors/viewOnlyModeSelectors';
import { toggleMemberCuttingMode } from '../store/slices/applicationSlice';

export function MemberCuttingEventListeners() {
  const dispatch = useAppDispatch();

  const viewOnly = useAppSelector(inViewOnlyMode);
  const inLayoutMode = useAppSelector(isLayoutViewActive);

  const selectedItem = useAppSelector(getSingleSelectedItemEntryOrNull);
  const active = useAppSelector((state) => state.application.inMemberCuttingMode);

  useEffect(() => {
    if (viewOnly || inLayoutMode || active === 'sticky') return;

    function onKeyDown(event: KeyboardEvent) {
      if (event.key === 'Shift' && (selectedItem?.type === 'member' || selectedItem?.type === 'brace')) {
        dispatch(toggleMemberCuttingMode(true));
      }
    }

    function onKeyup(event: KeyboardEvent) {
      if (event.key === 'Shift') {
        dispatch(toggleMemberCuttingMode(false));
      }
    }

    function onMouseMove(event: MouseEvent) {
      if (!event.shiftKey) {
        dispatch(toggleMemberCuttingMode(false));
      }
    }

    if (active) {
      document.addEventListener('keyup', onKeyup);
      document.addEventListener('mousemove', onMouseMove);

      return () => {
        document.removeEventListener('keyup', onKeyup);
        document.removeEventListener('mousemove', onMouseMove);
      };
    } else {
      document.addEventListener('keydown', onKeyDown);

      return () => {
        document.removeEventListener('keydown', onKeyDown);
      };
    }
  }, [active, dispatch, inLayoutMode, selectedItem, viewOnly]);

  return null;
}
